export default "__VITE_ASSET__rPSgAwo8__"